import React, { useContext, useMemo } from "react";
import CustomRecurrence from "../../../components/Tasks/RecurringTask/CustomRecurrence";
import RecurrenceAssignment from "../../../components/Tasks/RecurringTask/RecurrenceAssignment";
import RecurrenceModesAndDurations from "../../../components/Tasks/RecurringTask/RecurrenceModesAndDurations";
import RecurrenceRepeatTimes from "../../../components/Tasks/RecurringTask/RecurrenceRepeatTimes";
import { RecurringTaskContext } from "../../../components/Tasks/RecurringTask/RecurringTaskContext";
import { number } from "../../../config";

/**
 * Common Recurrence Component
 * Reusable recurrence configuration component for both automation triggers and tasks
 * Uses existing recurrence components to avoid code duplication
 * @author Muskan Thakur
 */
const CommonRecurrence = ({
  onRecurrenceChange = null,
  isAutomation = false,
  onEndDateChange = null,
  onEndCountChange = null,
  disabled = false,
  hideDisableButton = false,
}) => {
  const { recur } = useContext(RecurringTaskContext);

  const isTaskAssignmentEnabled = useMemo(() => !isAutomation, [isAutomation]);

  return (
    <div className={`common-recurrence w-100 mw-100 overflow-hidden ${isAutomation ? "automation-recurrence" : ""}`}>
      {/* Recurrence Pattern and Modes - Reuse existing component */}
      <div className='d-block'>
        <RecurrenceModesAndDurations isAutomation={isAutomation} disabled={disabled} hideDisableButton={hideDisableButton} />
      </div>

      {/* Custom Recurrence - Only show if enabled */}
      {recur?.value === number.FIVE && (
        <div className='d-block'>
          <CustomRecurrence />
        </div>
      )}

      {/* Repeat Times - Reuse existing component */}
      <div className='d-block'>
        <RecurrenceRepeatTimes
          isAutomation={isAutomation}
          onEndDateChange={onEndDateChange}
          onEndCountChange={onEndCountChange}
          disabled={disabled}
        />
      </div>

      {/* Assignment Section - Only show if enabled and reuse existing component */}
      {isTaskAssignmentEnabled && (
        <div className='mb-0 d-block'>
          <RecurrenceAssignment />
        </div>
      )}
    </div>
  );
};

export default CommonRecurrence;
